<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-progress-linear
        v-if="estilo === 'linear'"
        v-bind="attrs" v-on="on"
        background-color="grey lighten-2"
        :color="barColor"
        :value="porcentaje"
        height="15"
        striped
        rounded
      >
        <template v-slot:default="{ value }">
          <strong style="font-size: 14px">{{ Math.ceil(value) }}%</strong>
        </template>
      </v-progress-linear>
      <v-progress-circular
        v-else
        v-bind="attrs" v-on="on"
        :rotate="-90"
        :size="40"
        :width="4"
        :value="porcentaje"
        :color="barColor"
        >
          <strong style="font-size: 10px">{{ porcentaje }}%</strong>
      </v-progress-circular>
    </template>
    <span>
      {{ horasPonderadas }} horas ponderadas de {{ horasEstimadas }} horas estimadas.
      <br>
      {{ Math.round((horasEstimadas - horasPonderadas) * 100) / 100 }} horas restantes.
    </span>
  </v-tooltip>
</template>

<script>

export default {
  name: "ProgresoParte",
  
  props: {
    horasEstimadas: {
      type: Number,
      default: null
    },
    horasPonderadas: {
      type: Number,
      required: true
    },
    estilo: {
      type: String,
      default: 'linear'
    },
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  computed: {
    porcentaje(){
      return (this.horasPonderadas/this.horasEstimadas)*100;
    },
    barColor(){
      if(this.porcentaje < 60){
        return 'success';
      }else{
        if(this.porcentaje < 90){
          return 'warning';
        }else{
          return 'error';
        }
      }
    }
  },
  mounted() {

  },
};
</script>